<template>
    <v-row v-if="showAddress">
        <v-col cols="12" sm="6" md="12" class="py-0 my-1">
            <div class="pa-1 form-label">
                {{ $t("message.form.addressData.address") }} <strong>*</strong>
            </div>
            <v-text-field
                dense
                outlined
                hide-details="auto"
                v-bind:placeholder="$t('message.form.addressData.fillAddress')"
                v-model="parentAddress.address"
                :rules="national_address_Rule"
                required
                :disabled="is_same_other_address"
            >
                <template #message="{ message }">
                    {{ $t(message) }}
                </template>
            </v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="6" class="py-0 my-1">
            <div class="pa-1 form-label">
                {{ $t("message.form.addressData.province") }} <strong>*</strong>
            </div>
            <v-select
                dense
                outlined
                hide-details="auto"
                v-bind:placeholder="$t('message.form.addressData.fillProvince')"
                :items="provinces"
                :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                item-value="value"
                v-model="parentAddress.province"
                @change="onChangeProvince(parentAddress.province)"
                :rules="national_province_Rule"
                :disabled="is_same_other_address"
            >
                <template #message="{ message }">
                    {{ $t(message) }}
                </template>
            </v-select>
        </v-col>

        <v-col cols="12" sm="6" md="6" class="py-0 my-1">
            <div class="pa-1 form-label">
                {{ $t("message.form.addressData.district") }} <strong>*</strong>
            </div>
            <v-select
                :disabled="parentAddress.province?.length == 0 || is_same_other_address"
                dense
                outlined
                hide-details="auto"
                v-bind:placeholder="$t('message.form.addressData.fillDistrict')"
                :items="districts"
                :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                item-value="value"
                v-model="parentAddress.district"
                @change="onChangeDistrict(parentAddress.district)"
                :rules="national_district_Rule"
            >
                <template #message="{ message }">
                    {{ $t(message) }}
                </template>
            </v-select>
        </v-col>

        <v-col cols="12" sm="6" md="6" class="py-0 my-1">
            <div class="pa-1 form-label">
                {{ $t("message.form.addressData.subdistrict") }}
                <strong>*</strong>
            </div>
            <v-select
                :disabled="parentAddress.district?.length == 0 || is_same_other_address"
                dense
                outlined
                hide-details="auto"
                v-bind:placeholder="
                    $t('message.form.addressData.fillSubdistrict')
                "
                :items="subdistricts"
                :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                item-value="value"
                v-model="parentAddress.subdistrict"
                :rules="national_subdistrict_Rule"
            >
                <template #message="{ message }">
                    {{ $t(message) }}
                </template>
            </v-select>
        </v-col>

        <v-col cols="12" sm="6" md="6" class="py-0 my-1">
            <div class="pa-1 form-label">
                {{ $t("message.form.addressData.postalCode") }}
                <strong>*</strong>
            </div>
            <v-text-field
                dense
                outlined
                hide-details="auto"
                v-bind:placeholder="
                    $t('message.form.addressData.fillPostalCode')
                "
                v-model="parentAddress.postal_code"
                v-mask="'#########'"
                :rules="national_postal_Rule"
                :disabled="is_same_other_address"
            >
                <template #message="{ message }">
                    {{ $t(message) }}
                </template>
            </v-text-field>
        </v-col>
    </v-row>
</template>

<script>
import * as services from "@/services";
import i18n from '@/i18n';
export default {
    name: "AddressForm",
    data: () => ({
        parentAddress: {
            address: "",
            province: "",
            district: "",
            subdistrict: "",
            postal_code: "",
        },

        national_address_Rule: [
            (v) => !!v || "message.form.addressData.fillAddress",
        ],
        national_province_Rule: [
            (v) => !!v || "message.form.addressData.invalidProvince",
        ],
        national_district_Rule: [
            (v) => !!v || "message.form.addressData.invalidDistrict",
        ],
        national_subdistrict_Rule: [
            (v) => !!v || "message.form.addressData.invalidSubdistrict",
        ],
        national_postal_Rule: [
            (v) => !!v || "message.form.addressData.fillPostalCode",
        ],

        provinces: [],
        districts: [],
        subdistricts: [],

        isSet: false,
    }),
    props: {
        showAddress: Boolean,
        is_same_other_address: Boolean,
        otherAddress: Object,
        fetchTrigger: Boolean,
        form: String,
        from: String,
        dbAddress: Object,
    },
    computed: {
        locale(){
            return i18n.locale
        },
    },
    methods: {
        loadingUpdate(value) {
            this.$emit("loadingUpdate", value);
        },
        async fetchInitData() {
            try {
                this.loadingUpdate(1);
                let data = await getProvince();

                data.province.map((item) => {
                    this.provinces.push(item);
                });

                if(this.from == "candidates"){
                    this.isSet = true;
                }
            } finally{
                this.loadingUpdate(-1);
            }
        },
        async onChangeProvince(value) {
            try {
                this.loadingUpdate(1);
                let data = await getDistrict(value);
                this.districts = data.district;
            } catch (err) {
                return err;
            }
            finally {
                this.loadingUpdate(-1);
            }
        },
        async onChangeDistrict(value) {
            try {
                this.loadingUpdate(1);
                let data = await getSubdistrict(value);
                this.subdistricts = data.subdistrict;
            } catch (err) {
                return err;
            }
            finally {
                this.loadingUpdate(-1);
            }
        },
        async sameAddress(){
            if(this.otherAddress != null){
                if(this.otherAddress?.province != ""){
                    await this.onChangeProvince(this.otherAddress?.province)
                }
                if(this.otherAddress?.district != ""){
                    await this.onChangeDistrict(this.otherAddress?.district)
                }
                this.parentAddress = {
                    address: this.otherAddress.address,
                    province: this.otherAddress.province,
                    district: this.otherAddress.district,
                    subdistrict: this.otherAddress.subdistrict,
                    postal_code: this.otherAddress.postal_code,
                }
            }
        },
        async onSetDBdata(){
            if(this.from == "candidates" && this.isSet && this.dbAddress != null){
                if(this.dbAddress?.province != ""){
                    await this.onChangeProvince(this.dbAddress?.province)
                }
                if(this.dbAddress?.district != ""){
                    await this.onChangeDistrict(this.dbAddress?.district)
                }
                this.parentAddress = {
                    address: this.dbAddress?.address,
                    province: this.dbAddress?.province,
                    district: this.dbAddress?.district,
                    subdistrict: this.dbAddress?.subdistrict,
                    postal_code: this.dbAddress?.postal_code,
                }
            }
        }
    },
    mounted() {
        this.fetchInitData();
    },
    updated(){
        if(!this.is_same_other_address)
            this.$emit("updateSameAddress", this.parentAddress, this.form)
    },
    watch:{
        fetchTrigger(){
            if(this.is_same_other_address){
                this.sameAddress()
            }
        },
        is_same_other_address(){
            if(!this.is_same_other_address){
                this.parentAddress = {
                    address: "",
                    province: "",
                    district: "",
                    subdistrict: "",
                    postal_code: "",
                }
            }
            else{
                this.sameAddress()
            }
        },
        isSet(){
            if(this.from == "candidates" && this.isSet == true){
                this.onSetDBdata()
            }
        }

    }
};
const getProvince = async () => {
    const {
        data: { data },
    } = await services.getProvince();
    return data;
};

const getDistrict = async (province) => {
    const {
        data: { data },
    } = await services.getDistrictByProvince(province);
    return data;
};

const getSubdistrict = async (district) => {
    const {
        data: { data },
    } = await services.getSubdistrictByProvince(district);
    return data;
};
</script>